
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import HowWeHelpSection from './components/HowWeHelpSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import WhatWeLookForSection from './components/WhatWeLookForSection';
import ContactCTASection from './components/ContactCTASection';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <HowWeHelpSection />
        <WhyChooseUsSection />
        <WhatWeLookForSection />
        <ContactCTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
